import {
  FormCategoryWrapperType,
  FormCheckboxFieldType,
  FormFieldsetWrapperType,
  FormFileFieldType,
  FormFormeditorFieldType,
  FormGeneratorComponent,
  FormInputFieldType,
  FormPasswordFieldType,
  FormRadioFieldType,
  FormRootWrapperType,
  FormRowWrapperType,
  FormSelectFieldType,
  FormTextareaFieldType,
  FormToggleFieldType,
  FormViewerComponent,
} from './components';
import { FormDateFieldType } from './components/field-types/form-date-field';
import { FormFieldsArrayType } from './components/array-types/form-fields-array';

export * from './components';
export * from './types';
export * from './utils';
export const formsExports = [
  FormDateFieldType,
  FormFileFieldType,
  FormFormeditorFieldType,
  FormInputFieldType,
  FormPasswordFieldType,
  FormRadioFieldType,
  FormSelectFieldType,
  FormToggleFieldType,
  FormTextareaFieldType,
  FormCheckboxFieldType,

  FormFieldsArrayType,

  FormCategoryWrapperType,
  FormFieldsetWrapperType,
  FormRootWrapperType,
  FormRowWrapperType,

  FormGeneratorComponent,

  FormViewerComponent,
];

export const formsDeclarations = [...formsExports];
